let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hMjnL")).then(() => parcelRequire('8ehFz'));